import type { SvgProps } from "components/icons/types";

export const CommandKey = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <path
      d="M8.125 6.25H7.08333V3.75H8.125C9.15875 3.75 10 2.90875 10 1.875C10 0.84125 9.15875 0 8.125 0C7.09125 0 6.25 0.84125 6.25 1.875V2.91667H3.75V1.875C3.75 0.84125 2.90875 0 1.875 0C0.84125 0 0 0.84125 0 1.875C0 2.90875 0.84125 3.75 1.875 3.75H2.91667V6.25H1.875C0.84125 6.25 0 7.09125 0 8.125C0 9.15875 0.84125 10 1.875 10C2.90875 10 3.75 9.15875 3.75 8.125V7.08333H6.25V8.125C6.25 9.15875 7.09125 10 8.125 10C9.15875 10 10 9.15875 10 8.125C10 7.09125 9.15875 6.25 8.125 6.25ZM7.08333 1.875C7.08333 1.30083 7.55042 0.833333 8.125 0.833333C8.69958 0.833333 9.16667 1.30083 9.16667 1.875C9.16667 2.44917 8.69958 2.91667 8.125 2.91667H7.08333V1.875ZM1.875 2.91667C1.30042 2.91667 0.833333 2.44917 0.833333 1.875C0.833333 1.30083 1.30042 0.833333 1.875 0.833333C2.44958 0.833333 2.91667 1.30083 2.91667 1.875V2.91667H1.875ZM2.91667 8.125C2.91667 8.69917 2.44958 9.16667 1.875 9.16667C1.30042 9.16667 0.833333 8.69917 0.833333 8.125C0.833333 7.55083 1.30042 7.08333 1.875 7.08333H2.91667V8.125ZM3.75 6.25V3.75H6.25V6.25H3.75ZM8.125 9.16667C7.55042 9.16667 7.08333 8.69917 7.08333 8.125V7.08333H8.125C8.69958 7.08333 9.16667 7.55083 9.16667 8.125C9.16667 8.69917 8.69958 9.16667 8.125 9.16667Z"
      fill="currentColor"
    />
  </svg>
);
